export const ALERTDATEFORMAT = "MM/DD/YYYY"
export const GENASYS_LAYER_ID = 1
export const CUSTOM_LAYER_ID = 2